/** Тип запроса апи */
export enum MethodRequest {
  GET = 'GET',
  POST = 'POST'
}